import { Body, Box, Icon } from '@hover/blueprint';
import type { IconProp } from '@hover/icons';
import { iconMail, iconPhone, iconUser } from '@hover/icons';
import type { ReactNode } from 'react';
import React from 'react';

interface ContactInfoRowProps {
  icon: IconProp;
  children: ReactNode;
}

interface DesignContactInfoProps {
  name?: string;
  email?: string;
  phone?: string;
}

const ContactInfoRow: React.FC<ContactInfoRowProps> = ({ icon, children }) => (
  <Box alignItems="center">
    <Icon icon={icon} />
    <Body marginY={0}>{children}</Body>
  </Box>
);

export const DetailsContactInfo = ({
  name,
  email,
  phone,
}: DesignContactInfoProps) => {
  if (!name || !email) return null;

  return (
    <Box flexDirection="column" marginTop={600}>
      <ContactInfoRow icon={iconUser}>{name}</ContactInfoRow>
      {phone && <ContactInfoRow icon={iconPhone}>{phone}</ContactInfoRow>}
      <ContactInfoRow icon={iconMail}>{email}</ContactInfoRow>
    </Box>
  );
};
